import Vue from 'vue';
import {SectionsProvider} from '../../../content/providers/sections.provider';

export default Vue.component('ed-homework-feedback', {
  name: 'ed-homework-feedback',
  props: ['title'],
  components: {

  },
  data: () => {
    return {
      options : null
    }
  },
  methods: {
    closeFeedback(){
      this.$emit('onClose');
    },
    openModalFeedback(option){
      this.$emit('onSave', option);
    }
  },
  created() {
    this.options = SectionsProvider.getCreateObjectMenu(this.$i18n);
  },
  updated() {
    this.options = SectionsProvider.getCreateObjectMenu(this.$i18n);
  },
});
